// @ts-strict-ignore
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MAX_NAME_LENGTH } from '@/main/app.constants';
import { FormElement } from '@/hybrid/formbuilder/formBuilder.module';
import { SimpleSaveFormBuilder } from '@/hybrid/formbuilder/SimpleSaveFormBuilder.page';

interface AssetPropertiesModalProps {
  name: string;
  description: string;
  onClose: () => void;
  onSave: ({ name, description }: { name: string; description: string }) => void;
}

export const AssetPropertiesModal: React.FunctionComponent<AssetPropertiesModalProps> = ({
  onClose,
  onSave,
  name,
  description,
}) => {
  const { t } = useTranslation();

  const [assetGroupName, setAssetGroupName] = useState<string>(name);
  const [assetGroupDescription, setAssetGroupDescription] = useState<string>(description);

  const formDefinition: FormElement[] = [
    {
      component: 'FormControlFormComponent',
      name: 'assetGroupName',
      label: 'NAME',
      value: assetGroupName,
      size: 'lg',
      placeholder: 'ASSET_GROUP_EDITOR.NAME_PLACEHOLDER',
      maxLength: MAX_NAME_LENGTH.TOOL,
      onChange: (name: string) => setAssetGroupName(name),
      testId: 'assetGroupModalNameInput',
      required: true,
    },
    {
      component: 'FormControlFormComponent',
      name: 'assetGroupDescription',
      label: 'DESCRIPTION',
      value: assetGroupDescription,
      testId: 'assetGroupModalDescriptionInput',
      size: 'lg',
      onChange: (description: string) => setAssetGroupDescription(description),
      as: 'textarea',
      rows: 5,
      validation: () => false,
    },
  ];

  return (
    <Modal show={true} onHide={onClose} animation={false} data-testid="assetGroupPropertiesModal">
      <Modal.Header closeButton={true}>
        <h3>{t('ASSET_GROUP_EDITOR.EDIT_GROUP')}</h3>
      </Modal.Header>
      <Modal.Body>
        <SimpleSaveFormBuilder
          formDefinition={formDefinition}
          submitFn={() => onSave({ name: assetGroupName, description: assetGroupDescription })}
          submitBtnLabel="APPLY"
          closeFn={onClose}
        />
      </Modal.Body>
    </Modal>
  );
};
